import { z } from "zod";
import { uuidSchema } from "../utils/uuid";

export const databaseInfoSchema = z.object({
  uuid: uuidSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const updatedByObjectSchema = z.object({
  manager: uuidSchema.optional(),
  admin: z.string().optional(),
  driver: uuidSchema.optional(),
});

export const updatedBySchema = updatedByObjectSchema.nullable();

export const reviewersTypesSchema = updatedByObjectSchema;

export const reviewerSchema = reviewersTypesSchema.nullable();

export type DatabaseInfoType = z.infer<typeof databaseInfoSchema>;
export type UpdatedByType = z.infer<typeof updatedBySchema>;
export type ReviewersTypesType = z.infer<typeof reviewersTypesSchema>;
export type ReviewerType = z.infer<typeof reviewerSchema>;
